'use client'
import { FormEventHandler, useMemo } from 'react'

import { useTranslation } from '../../../context/ConfigContext'
import CustomSelect from '../../Form/InputWrapper/CustomSelect'
import { InputRadiusCityProps, TypeRadius } from '../types'
import { RADIUS_TYPE_KM, RADIUS_TYPE_MILES } from '../constants'
import { buildLinearGradientFromPercent } from '../helper'
import useCurrentLocale from '../../../../core/hook/useCurrentLocale'
import { getIsArabicLocale } from '../../../utils/locale.utils'

const InputRadiusCity = ({ onChange, value, typeRadius }: InputRadiusCityProps) => {
  const currentLocale = useCurrentLocale()
  const isArabicLocale = getIsArabicLocale(currentLocale)
  const t = useTranslation()

  const percentPosition = useMemo(() => (value * 100) / 50, [value])

  const computeCssStyleOfTooltip = useMemo(() => {
    if (isArabicLocale) {
      return {
        right: `${percentPosition}%`,
        transform: `translate(${1 * percentPosition}%, 0)`,
      }
    }

    return {
      left: `${percentPosition}%`,
      transform: `translate(${-1 * percentPosition}%, 0)`,
    }
  }, [isArabicLocale, percentPosition])

  const onChangeRadiusValue: FormEventHandler<HTMLInputElement> | undefined = (e) => {
    const newValue = Number(e.currentTarget.value)
    onChange(newValue, typeRadius)
  }

  return (
    <div className='sellers-page-filter-radius'>
      <div className='sellers-page-filter-radius-unity'>
        <label>{t('Search Radius')}</label>
        <CustomSelect
          selectedValue={typeRadius}
          onChange={(newTypeRadius: TypeRadius) => onChange(value, newTypeRadius)}
          list={[
            {
              title: t('km', {}, false),
              value: RADIUS_TYPE_KM,
              id: RADIUS_TYPE_KM,
            },
            {
              title: t('mi', {}, false),
              value: RADIUS_TYPE_MILES,
              id: RADIUS_TYPE_MILES,
            },
          ]}
        />
      </div>
      <div className='sellers-page-filter-radius-range'>
        <input
          type='range'
          name='radius'
          min={0}
          max={50}
          onInput={onChangeRadiusValue}
          value={value}
          style={{
            background: buildLinearGradientFromPercent(
              percentPosition,
              isArabicLocale ? 'to left' : 'to right',
            ),
          }}
        />
        <span className='sellers-page-filter-radius-range-tooltip' style={computeCssStyleOfTooltip}>
          {value} {typeRadius}
        </span>
      </div>
    </div>
  )
}

export default InputRadiusCity
